export enum CategoryType {
	CATEGORIES = 'categories',
	INDUSTRIES = 'industries',
	PRODUCTS = 'products',
}
